<script setup lang="ts">
import SkeletonSummaryCard from './parts/SummaryCard.vue';
import EmptyStateIconUrl from '@Shared/components/visuals/visualAssets/EmptyState_Icon.svg?url';
defineProps<{
  hasNoData?: boolean;
}>();
</script>
<template>
  <div
    v-if="hasNoData"
    class="absolute left-0 text-center w-full text-[#828282] xl:text-3 font-family[Roboto] xl:line-height-1rem xl:top-55% xs:text-4 xs:line-height-1.5rem xs:top-25% xs:pt-12 xl:pt-0"
  >
    <img :src="EmptyStateIconUrl" alt="" />
    <div class="xl:max-w-[200px] m-auto xs:max-w-[240px]">
      <span>
        No feedback to display. <br />
        Nothing to see here at the moment.
      </span>
    </div>
  </div>
  <div class="overflow-auto hide-scrollbar-auto flex flex-col px-3">
    <div class="flex flex-col gap-2 m-t-7 overflow-hidden">
      <SkeletonSummaryCard v-for="i in 8" :key="i" />
    </div>
  </div>
</template>
